// extracted by mini-css-extract-plugin
export default {"typography":"afOLn","tahoma":"vaW7G","gess":"W9FLM","regular":"NOhOP","medium":"WjkCL","semiBold":"LSzP8","bold":"KBE0L"};